module.exports = "/_next/static/images/instagram-2-842fca43187ea486783c0efbca497a65.png";